import { toString, Union } from "./fable_modules/fable-library-js.4.24.0/Types.js";
import { union_type } from "./fable_modules/fable-library-js.4.24.0/Reflection.js";
import { toArray, tail, head, isEmpty, ofArray, singleton } from "./fable_modules/fable-library-js.4.24.0/List.js";
import { createElement } from "react";
import React from "react";
import { ThemeType, ContextMsg, useCtx } from "./Context.jsx";
import { reactApi } from "./fable_modules/Feliz.2.9.0/Interop.fs.js";
import { useFeliz_React__React_useResponsive_Static_Z434A9929 } from "./fable_modules/Feliz.UseMediaQuery.1.5.0/UseMediaQuery.fs.js";
import { RouterModule_nav, RouterModule_encodeParts, RouterModule_urlSegments } from "./fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import { useEffectOnce } from "./fable_modules/Feliz.2.9.0/Internal.fs.js";
import { Caption2, NavDivider, NavSubItem, NavSubItemGroup, NavCategoryItem, NavCategory, NavItem, Divider, Image, NavDrawerBody, tokens, NavDrawer } from "@fluentui/react-components";
import { equals, createObj } from "./fable_modules/fable-library-js.4.24.0/Util.js";
import { empty, singleton as singleton_1, append, delay, toList } from "./fable_modules/fable-library-js.4.24.0/Seq.js";
import { SignOutRegular, SignOutFilled, SettingsRegular, SettingsFilled, LayerDiagonalPersonRegular, LayerDiagonalPersonFilled, BookOpenRegular, BookOpenFilled, bundleIcon, HomeRegular, HomeFilled } from "@fluentui/react-icons";
import { BundleIcons } from "./fable_modules/FS.FluentUI.2.5.2/Utils.fs.js";
import { reactApi as reactApi_1 } from "./fable_modules/Feliz.2.9.0/Interop.fs.js";

export class Tabs extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Home", "Courses", "Tracks", "ApproveUsers", "CourseTemplates", "Workplaces", "Regions"];
    }
    toString() {
        const this$ = this;
        return (this$.tag === 1) ? "Kurs" : ((this$.tag === 2) ? "Kursløp" : ((this$.tag === 3) ? "Godkjenn brukere" : ((this$.tag === 4) ? "Kursmaler" : ((this$.tag === 5) ? "Arbeidsplasser" : ((this$.tag === 6) ? "Regioner" : "Hjem")))));
    }
}

export function Tabs_$reflection() {
    return union_type("Sidebar.Tabs", [], Tabs, () => [[], [], [], [], [], [], []]);
}

export function Tabs__ToUrl(this$) {
    switch (this$.tag) {
        case 1:
            return singleton("kurs");
        case 2:
            return singleton("kurslop");
        case 3:
            return ofArray(["admin", "bruker", "godkjenn"]);
        case 4:
            return ofArray(["kurslop", "bygger", "kursmal"]);
        case 5:
            return ofArray(["admin", "arbeidsplasser"]);
        case 6:
            return ofArray(["admin", "regioner"]);
        default:
            return singleton("");
    }
}

export function Tabs_FromUrl_7F866359(url) {
    let matchResult;
    if (!isEmpty(url)) {
        switch (head(url)) {
            case "admin": {
                if (!isEmpty(tail(url))) {
                    switch (head(tail(url))) {
                        case "bruker": {
                            if (!isEmpty(tail(tail(url)))) {
                                if (head(tail(tail(url))) === "godkjenn") {
                                    if (isEmpty(tail(tail(tail(url))))) {
                                        matchResult = 0;
                                    }
                                    else {
                                        matchResult = 6;
                                    }
                                }
                                else {
                                    matchResult = 6;
                                }
                            }
                            else {
                                matchResult = 6;
                            }
                            break;
                        }
                        case "arbeidsplasser": {
                            if (isEmpty(tail(tail(url)))) {
                                matchResult = 1;
                            }
                            else {
                                matchResult = 6;
                            }
                            break;
                        }
                        case "regioner": {
                            if (isEmpty(tail(tail(url)))) {
                                matchResult = 3;
                            }
                            else {
                                matchResult = 6;
                            }
                            break;
                        }
                        default:
                            matchResult = 6;
                    }
                }
                else {
                    matchResult = 6;
                }
                break;
            }
            case "bruker": {
                if (!isEmpty(tail(url))) {
                    if (head(tail(url)) === "kursmal") {
                        if (isEmpty(tail(tail(url)))) {
                            matchResult = 2;
                        }
                        else {
                            matchResult = 6;
                        }
                    }
                    else {
                        matchResult = 6;
                    }
                }
                else {
                    matchResult = 6;
                }
                break;
            }
            case "kurs": {
                if (isEmpty(tail(url))) {
                    matchResult = 4;
                }
                else {
                    matchResult = 6;
                }
                break;
            }
            case "kurslop": {
                if (isEmpty(tail(url))) {
                    matchResult = 5;
                }
                else {
                    matchResult = 6;
                }
                break;
            }
            case "": {
                if (isEmpty(tail(url))) {
                    matchResult = 6;
                }
                else {
                    matchResult = 6;
                }
                break;
            }
            default:
                matchResult = 6;
        }
    }
    else {
        matchResult = 6;
    }
    switch (matchResult) {
        case 0:
            return new Tabs(3, []);
        case 1:
            return new Tabs(5, []);
        case 2:
            return new Tabs(4, []);
        case 3:
            return new Tabs(6, []);
        case 4:
            return new Tabs(1, []);
        case 5:
            return new Tabs(2, []);
        default:
            return new Tabs(0, []);
    }
}

export function Sidebar() {
    const patternInput = useCtx();
    const setCtx = patternInput[1];
    const ctx = patternInput[0];
    const navBarRef = reactApi.useRef(undefined);
    const screenSize = useFeliz_React__React_useResponsive_Static_Z434A9929();
    let patternInput_1;
    const initial = Tabs_FromUrl_7F866359(RouterModule_urlSegments(window.location.hash, 1));
    patternInput_1 = reactApi.useState(initial);
    const setSelectedTab = patternInput_1[1];
    useEffectOnce(() => {
        if (ctx.NavbarOpen) {
            document.addEventListener("click", (ev) => {
                let el;
                const matchValue = navBarRef.current;
                let matchResult, el_1;
                if (matchValue != null) {
                    if ((el = matchValue, !el.contains(ev.target))) {
                        matchResult = 0;
                        el_1 = matchValue;
                    }
                    else {
                        matchResult = 1;
                    }
                }
                else {
                    matchResult = 1;
                }
                switch (matchResult) {
                    case 0: {
                        setCtx(new ContextMsg(3, [false]));
                        break;
                    }
                    case 1: {
                        break;
                    }
                }
            });
        }
    });
    const el_34 = NavDrawer;
    return createElement(el_34, createObj(toList(delay(() => append(singleton_1(["ref", navBarRef]), delay(() => append(singleton_1(["style", {
        height: ("calc(" + "100vh") + ")",
        width: 260,
        backgroundColor: tokens.colorNeutralBackground1,
    }]), delay(() => append(singleton_1(["selectedValue", toString(patternInput_1[0])]), delay(() => append(singleton_1(["onNavItemSelect", (_arg_1, value_1_2) => {
        switch (screenSize.tag) {
            case 0:
            case 1:
            case 2: {
                setCtx(new ContextMsg(3, [false]));
                break;
            }
            default:
                undefined;
        }
    }]), delay(() => append(singleton_1(["open", (screenSize.tag === 0) ? ctx.NavbarOpen : ((screenSize.tag === 1) ? ctx.NavbarOpen : ((screenSize.tag === 2) ? ctx.NavbarOpen : true))]), delay(() => append(singleton_1(["multiple", false]), delay(() => {
        let matchValue_1;
        return append((matchValue_1 = screenSize, (matchValue_1.tag === 0) ? singleton_1(["type", "overlay"]) : ((matchValue_1.tag === 1) ? singleton_1(["type", "overlay"]) : ((matchValue_1.tag === 2) ? singleton_1(["type", "overlay"]) : singleton_1(["type", "inline"])))), delay(() => append(singleton_1(["size", "large"]), delay(() => {
            let elems_5, el_32, elems_4;
            return singleton_1((elems_5 = [(el_32 = NavDrawerBody, createElement(el_32, createObj(singleton((elems_4 = toList(delay(() => {
                let elems_1, el_2, elems, el_4;
                return append(singleton_1(createElement("div", createObj(ofArray([["style", {
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    height: 60,
                    width: 100 + "%",
                }], (elems_1 = [(el_2 = Image, createElement(el_2, createObj(toList(delay(() => append(singleton_1(["style", {
                    margin: 0,
                    padding: 0,
                }]), delay(() => append(equals(ctx.ThemeType, new ThemeType(0, [])) ? singleton_1(["src", "/images/logoWithText.png"]) : singleton_1(["src", "/images/iipdark.png"]), delay(() => append(singleton_1(["height", 35]), delay(() => singleton_1(["fit", "contain"])))))))))))), createElement("div", createObj(ofArray([["style", {
                    justifySelf: "flex-end",
                }], (elems = [(el_4 = Divider, createElement(el_4, {
                    appearance: "subtle",
                }))], ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))), delay(() => {
                    let el_6, icons_1, value_1_9, value_2_1;
                    return append(singleton_1((el_6 = NavItem, createElement(el_6, {
                        href: RouterModule_encodeParts(Tabs__ToUrl(new Tabs(0, [])), 1),
                        onClick: (_arg_2) => {
                            setSelectedTab(new Tabs(0, []));
                            RouterModule_nav(ofArray(toArray(Tabs__ToUrl(new Tabs(0, [])))), 1, 1);
                        },
                        icon: (icons_1 = (new BundleIcons((value_1_9 = HomeFilled, value_1_9), (value_2_1 = HomeRegular, value_2_1))), bundleIcon([icons_1.Filled, icons_1.Regular][0], [icons_1.Filled, icons_1.Regular][1])({
                            fontSize: 24,
                        })),
                        value: toString(new Tabs(0, [])),
                        children: toString(new Tabs(0, [])),
                    }))), delay(() => {
                        let el_8, icons_3, value_1_14, value_2_2;
                        return append(singleton_1((el_8 = NavItem, createElement(el_8, {
                            href: RouterModule_encodeParts(Tabs__ToUrl(new Tabs(1, [])), 1),
                            onClick: (_arg_3) => {
                                setSelectedTab(new Tabs(1, []));
                                RouterModule_nav(ofArray(toArray(Tabs__ToUrl(new Tabs(1, [])))), 1, 1);
                            },
                            icon: (icons_3 = (new BundleIcons((value_1_14 = BookOpenFilled, value_1_14), (value_2_2 = BookOpenRegular, value_2_2))), bundleIcon([icons_3.Filled, icons_3.Regular][0], [icons_3.Filled, icons_3.Regular][1])({
                                fontSize: 24,
                            })),
                            value: toString(new Tabs(1, [])),
                            children: toString(new Tabs(1, [])),
                        }))), delay(() => {
                            let el_10, icons_5, value_1_19, value_2_3;
                            return append(singleton_1((el_10 = NavItem, createElement(el_10, {
                                href: RouterModule_encodeParts(Tabs__ToUrl(new Tabs(2, [])), 1),
                                onClick: (_arg_4) => {
                                    setSelectedTab(new Tabs(2, []));
                                    RouterModule_nav(ofArray(toArray(Tabs__ToUrl(new Tabs(2, [])))), 1, 1);
                                },
                                icon: (icons_5 = (new BundleIcons((value_1_19 = LayerDiagonalPersonFilled, value_1_19), (value_2_3 = LayerDiagonalPersonRegular, value_2_3))), bundleIcon([icons_5.Filled, icons_5.Regular][0], [icons_5.Filled, icons_5.Regular][1])({
                                    fontSize: 24,
                                })),
                                value: toString(new Tabs(2, [])),
                                children: toString(new Tabs(2, [])),
                            }))), delay(() => {
                                let el_24, elems_3, el_12, icons_7, value_1_24, value_2_4, el_22, elems_2, el_14, el_16, el_18, el_20;
                                return append(ctx.User.IsAdmin ? singleton_1((el_24 = NavCategory, createElement(el_24, createObj(ofArray([["value", "Admin"], (elems_3 = [(el_12 = NavCategoryItem, createElement(el_12, {
                                    icon: (icons_7 = (new BundleIcons((value_1_24 = SettingsFilled, value_1_24), (value_2_4 = SettingsRegular, value_2_4))), bundleIcon([icons_7.Filled, icons_7.Regular][0], [icons_7.Filled, icons_7.Regular][1])({
                                        fontSize: 24,
                                    })),
                                    value: "Admin",
                                    children: "Admin",
                                })), (el_22 = NavSubItemGroup, createElement(el_22, createObj(singleton((elems_2 = [(el_14 = NavSubItem, createElement(el_14, {
                                    href: RouterModule_encodeParts(Tabs__ToUrl(new Tabs(5, [])), 1),
                                    onClick: (_arg_5) => {
                                        setSelectedTab(new Tabs(5, []));
                                        RouterModule_nav(ofArray(toArray(Tabs__ToUrl(new Tabs(5, [])))), 1, 1);
                                    },
                                    value: toString(new Tabs(5, [])),
                                    children: toString(new Tabs(5, [])),
                                })), (el_16 = NavSubItem, createElement(el_16, {
                                    href: RouterModule_encodeParts(Tabs__ToUrl(new Tabs(4, [])), 1),
                                    onClick: (_arg_6) => {
                                        setSelectedTab(new Tabs(4, []));
                                        RouterModule_nav(ofArray(toArray(Tabs__ToUrl(new Tabs(4, [])))), 1, 1);
                                    },
                                    value: toString(new Tabs(4, [])),
                                    children: toString(new Tabs(4, [])),
                                })), (el_18 = NavSubItem, createElement(el_18, {
                                    href: RouterModule_encodeParts(Tabs__ToUrl(new Tabs(3, [])), 1),
                                    onClick: (_arg_7) => {
                                        setSelectedTab(new Tabs(3, []));
                                        RouterModule_nav(ofArray(toArray(Tabs__ToUrl(new Tabs(3, [])))), 1, 1);
                                    },
                                    value: toString(new Tabs(3, [])),
                                    children: toString(new Tabs(3, [])),
                                })), (el_20 = NavSubItem, createElement(el_20, {
                                    href: RouterModule_encodeParts(Tabs__ToUrl(new Tabs(6, [])), 1),
                                    onClick: (_arg_8) => {
                                        setSelectedTab(new Tabs(6, []));
                                        RouterModule_nav(ofArray(toArray(Tabs__ToUrl(new Tabs(6, [])))), 1, 1);
                                    },
                                    value: toString(new Tabs(6, [])),
                                    children: toString(new Tabs(6, [])),
                                }))], ["children", reactApi_1.Children.toArray(Array.from(elems_2))])))))], ["children", reactApi_1.Children.toArray(Array.from(elems_3))])]))))) : empty(), delay(() => append(singleton_1(createElement("div", {
                                    style: {
                                        flexGrow: 3,
                                    },
                                })), delay(() => {
                                    let el_26;
                                    return append(singleton_1((el_26 = NavDivider, createElement(el_26, {}))), delay(() => {
                                        let el_28, icons_9, value_1_41, value_2_5;
                                        return append(singleton_1((el_28 = NavItem, createElement(el_28, {
                                            href: "/api/logout",
                                            icon: (icons_9 = (new BundleIcons((value_1_41 = SignOutFilled, value_1_41), (value_2_5 = SignOutRegular, value_2_5))), bundleIcon([icons_9.Filled, icons_9.Regular][0], [icons_9.Filled, icons_9.Regular][1])({
                                                fontSize: 24,
                                            })),
                                            children: "Logg ut",
                                        }))), delay(() => {
                                            let el_30, matchValue_2;
                                            return singleton_1((el_30 = Caption2, createElement(el_30, {
                                                style: {
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    marginBottom: 15,
                                                    color: tokens.colorNeutralForeground3,
                                                },
                                                align: "center",
                                                children: (matchValue_2 = ctx.AppVersion, (matchValue_2 != null) ? (`Av Serit Tromsø - ${matchValue_2}`) : "Av Serit Tromsø"),
                                            })));
                                        }));
                                    }));
                                }))));
                            }));
                        }));
                    }));
                }));
            })), ["children", reactApi_1.Children.toArray(Array.from(elems_4))])))))], ["children", reactApi_1.Children.toArray(Array.from(elems_5))]));
        }))));
    }))))))))))))))));
}

//# sourceMappingURL=Sidebar.jsx.map
